import type { ParentComponent } from "solid-js";
import { Show } from "solid-js";
import { Title } from "@solidjs/meta";
import { DownloadStep, SetupStep } from "~/link_setup/steps";
import { formatDateTime } from "~/util/format";
import { linkSetupDownloadPath } from "~/routes";

type PairingCode = {
  code: string;
  expiresAt: string;
};

type Props = {
  token: string;
  installerAvailable: boolean;
  pairingCode: PairingCode | null;
};

const PublicPageLayout: ParentComponent = (props) => <>{props.children}</>;

function LinkSetupShow(props: Props) {
  return (
    <>
      <Title>Set up Twelve Link</Title>

      <div class="mx-auto flex min-h-screen w-full max-w-xl flex-col gap-6 p-6 sm:p-12">
        <header class="text-center">
          <h1 class="text-2xl font-semibold text-typography-primary">Set up Twelve Link</h1>
          <p class="mt-2 text-typography-secondary">
            Follow the steps below to connect your practice to Twelve.
          </p>
        </header>

        <ol class="flex flex-col gap-6">
          <DownloadStep
            href={linkSetupDownloadPath(props.token)}
            available={props.installerAvailable}
          >
            Download Twelve Link and run the installer on the computer that connects to your
            practice management system.
          </DownloadStep>

          <SetupStep number={2} title="Enter your setup code">
            <p class="text-sm text-typography-secondary">
              When Twelve Link opens, enter this one-time setup code to pair it with your practice.
            </p>
            <Show
              when={props.pairingCode}
              fallback={
                <p class="mt-4 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
                  This setup code has expired. Please contact your Twelve representative for a new
                  one.
                </p>
              }
            >
              {(code) => (
                <div class="mt-4">
                  <code class="inline-block rounded-lg bg-gray-100 px-6 py-3 text-3xl font-bold tracking-widest text-typography-primary">
                    {code().code}
                  </code>
                  <p class="mt-2 text-xs text-typography-secondary">
                    This setup link expires {formatDateTime(code().expiresAt)}.
                  </p>
                </div>
              )}
            </Show>
          </SetupStep>
        </ol>
      </div>
    </>
  );
}

LinkSetupShow.layout = PublicPageLayout;
export default LinkSetupShow;
